module.exports = __webpack_public_path__ + "img/bg-7.e2de28e3.jpg";